import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "feature"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_horizontal_article = _resolveComponent("horizontal-article");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_horizontal_article, {
    data: _ctx.featurePost
  }, null, 8 /* PROPS */, ["data"]), _createCommentVNode(" Feature sub-component "), _renderSlot(_ctx.$slots, "default")]);
}